import React from 'react'

const Clickable = props => <div {...props} style={{ cursor: 'pointer' }} />

export default Clickable
